import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IQuotationScore, IkillStock, IKillStockQuote } from '../../models/quotations.models';
import { environment } from 'src/environments/environment';

export interface IKillStockDialogData {
  quote_name: string;
  score: IQuotationScore;
  overall_score: number;
}

@Component({
  selector: 'app-kill-stock-details',
  templateUrl: './kill-stock-details.component.html',
  styleUrls: ['./kill-stock-details.component.scss']
})
export class KillStockDetailsComponent implements OnInit {
  placeholder: string = 'assets/images/placeholder.png';
  baseUrl = environment.BASE_URL_API;
  expandedProducts: Set<number> = new Set<number>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IKillStockDialogData,
    public dialogRef: MatDialogRef<KillStockDetailsComponent>
  ) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  close(): void {
    this.dialogRef.close();
  }

  toggleProduct(productId: number): void {
    if (this.expandedProducts.has(productId)) {
      this.expandedProducts.delete(productId);
    } else {
      this.expandedProducts.add(productId);
    }
  }

  isProductExpanded(productId: number): boolean {
    return this.expandedProducts.has(productId);
  }
}
